export const session = {
  state: {
    sessions: [],
    loadingAttendees: false
  },
  mutations: {
    addSession (state, payload) {
      state.sessions = state.sessions.concat(payload)
    },
    setSessions (state, payload) {
      state.sessions = payload
    },
    setSessionAttendeesLoading (state, payload) {
      state.loadingAttendees = payload
    }
  },
  actions: {
    addSession ({ commit }, payload) {
      return commit('addSession', payload)
    },
    setSessions ({ commit }, payload) {
      return commit('setSessions', payload)
    },
    setSessionAttendeesLoading ({ commit }, payload) {
      return commit('setSessionAttendeesLoading', payload)
    }
  },
  getters: {
    getSessions (state) {
      return state.sessions
    },
    getSessionAttendeesLoading (state) {
      return state.loadingAttendees
    }
  }
}
